import { format, parse } from 'date-fns';
import { formatInTimeZone, fromZonedTime } from 'date-fns-tz';
import { getTimezone } from 'utils/shared/time/getTimezone';

interface TimeSlotParams {
  date: Date; // Expecting format 'yyyy-MM-dd'
  time: string; // Expecting format 'HH:mm'
  timezone?: string | null;
}

// Interprets date+time as wall-clock IN `timezone` and returns the UTC instant.
export function convertToUtc({ date, time, timezone }: TimeSlotParams) {
  const tz = getTimezone(timezone);

  const timestampLocal = `${format(date, 'yyyy-MM-dd')}T${time}:00`;
  const dateInZone = parse(timestampLocal, "yyyy-MM-dd'T'HH:mm:ss", new Date());
  const utcDate = fromZonedTime(dateInZone, tz);

  return formatInTimeZone(utcDate, 'UTC', "yyyy-MM-dd'T'HH:mm:ssXXX");
}
